import styled from 'styled-components';
import { nearlyBlack } from './../variables';

export default styled.h3`
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    color: ${nearlyBlack};
`;
